import subscribeDialog from './index.vue';
 
// 定义插件对象
const SubscribeDialog = {};
// vue的install方法，用于定义vue插件
SubscribeDialog.install = function (Vue, options) {
  const SubscribeDialogInstance = Vue.extend(subscribeDialog);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new SubscribeDialogInstance();
    let msgBoxEl = currentMsg.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$subscribeDialog = {
    showSubscribeDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      if (typeof options === 'string') {
        currentMsg.content = options;
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options);
      }
      currentMsg.showMsgBox();
    },
    hideSubscribeDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      currentMsg.cancel();
    }
  };
};
 
export default SubscribeDialog;


// WEBPACK FOOTER //
// ./src/components/common/subscribe-dialog/index.js